import { Analytics } from './analytics'

type ShareAnalyticsInitiatedFrom = 'Session finalisation' | 'Documents' | 'Proposals' | 'Value Gap Calculator' | 'Meeting deliverable'
type ShareAnalyticsShareAction = 'Exported to FYI' | 'Exported to PDF' | 'Invite user'

export enum ShareAnalyticsPropertyEvent {
   initiatedFrom = 'Initiated from',
   shareAction = 'Share action',
   integrationName = 'Integration name'
}

export enum ShareAnalyticsEvent {
   documentShared = 'Document shared',
   integrationConnection = 'Integration connected'
}

export default class ShareAnalytics implements Analytics {
   static documentShared = (params: { [ShareAnalyticsPropertyEvent.initiatedFrom]: ShareAnalyticsInitiatedFrom, [ShareAnalyticsPropertyEvent.shareAction]: ShareAnalyticsShareAction }) => {
      return Analytics.emitEvent(ShareAnalyticsEvent.documentShared, {
         [ShareAnalyticsPropertyEvent.initiatedFrom]: params[ShareAnalyticsPropertyEvent.initiatedFrom],
         [ShareAnalyticsPropertyEvent.shareAction]: params[ShareAnalyticsPropertyEvent.shareAction],
      })
   }

   static connectToFYIViaShareComponent = () => {
      return Analytics.emitEvent(ShareAnalyticsEvent.integrationConnection, {
         [ShareAnalyticsPropertyEvent.integrationName]: 'FYI',
      })
   }
}
